<h1 class="title" translate>HOMEPAGE.MANAGE_CERT.TITLE</h1>
<app-page-wrapper>
  <div class="ic1-my-12">
    <ng-ui-kit-toast
      *ngIf="showSuccess"
      status="success"
      [text]="
        'SUSPEND_PAGE.SUCCESS' | translate: { state: (successText | translate) }
      "></ng-ui-kit-toast>
  </div>

  <!-- Gestisci Certificato FA -->
  <div class="ic1-my-12">
    <ng-ui-kit-card
      *ngIf="automatic && isPkBox"
      [header]="true"
      [data]="true"
      className="type-2"
      [text]="
        'SUSPEND_PAGE.AUTOMATIC_CARD.DESC'
          | translate: { state: (descText | translate) }
      "
      type="summative"
      [button]="cardFAButton"
      [attr.translate-key]="'SUSPEND_PAGE.AUTOMATIC_CARD.DESC'">
      <ng-container header>
        <div class="ic1-header-left">
          <label class="ic1-text-label-1" translate
            >SUSPEND_PAGE.AUTOMATIC_CARD.TITLE</label
          >
          <ng-ui-kit-badge
            [color]="active ? 'success' : 'warning'"
            size="sm"
            [label]="
              'SUSPEND_PAGE.AUTOMATIC_CARD.ICON_TEXT'
                | translate: { state: (iconText | translate) }
            "></ng-ui-kit-badge>
        </div>
      </ng-container>
      <div class="view-data-mobile" data>
        <span
          [ngClass]="
            active
              ? 'ic1-badge-success-alternative'
              : 'ic1-badge-warning-alternative'
          ">
          <span
            [HTMLTranslate]="
              'SUSPEND_PAGE.AUTOMATIC_CARD.ICON_TEXT'
                | translate: { state: (iconText | translate) }
            "></span>
        </span>
        <label
          class="ic1-text-body-1"
          [HTMLTranslate]="
            'SUSPEND_PAGE.AUTOMATIC_CARD.DESC'
              | translate: { state: (descText | translate) }
          "></label>
      </div>
    </ng-ui-kit-card>
  </div>
</app-page-wrapper>
<app-common-modal
  modalId="manage-cert-modal"
  [title]="'SUSPEND_PAGE.AUTOMATIC_CARD.TITLE' | translate"
  [(visible)]="manageCertModalVisible"
  [config]="{ size: 'lg', persistent: true, hideButtons: true }"
  (onClose)="onToggleManageCertModal(false)">
  <form
    [formGroup]="form"
    *ngIf="showStep1 || showStep2"
    (ngSubmit)="onSubmit()">
    <!-- FIRST STEP START-->
    <div class="ic1-my-16">
      <ng-ui-kit-accordion
        [disabled]="showStep2"
        [title]="
          'SUSPEND_PAGE.AUTOMATIC_CARD.ACCORDION.FIRST_STEP.TITLE'
            | translate
              : {
                  state: (buttonText | translate),
                }
        "
        [open]="showStep1"
        [icon]="!showStep1 ? 'check' : ''"
        [step]="showStep1 ? 1 : 0">
        <ng-container content>
          <div class="ic1-row">
            <div
              class="ic1-col-12 desc ic1-my-12"
              [HTMLTranslate]="
                'SUSPEND_PAGE.AUTOMATIC_CARD.ACCORDION.FIRST_STEP.DESC'
                  | translate: { state: (descText | translate) }
              "></div>
            <div class="ic1-col-12 ic1-col-lg-6">
              <ng-ui-kit-input
                formControlName="pin"
                name="pin"
                autocomplete="pin"
                [placeholder]="
                  'SUSPEND_PAGE.AUTOMATIC_CARD.ACCORDION.FIRST_STEP.PIN_PLACEHOLDER'
                    | translate
                "
                [OnlyNumbers]="8"
                type="password"
                icName="pin"
                icId="pin"
                [label]="
                  'SUSPEND_PAGE.AUTOMATIC_CARD.ACCORDION.FIRST_STEP.PIN_LABEL'
                    | translate
                "
                [status]="
                  step1Attempted && pin.invalid
                    ? 'error'
                    : 'informative'
                ">
              </ng-ui-kit-input>
              <app-field-validator
                *ngIf="step1Attempted"
                [field]="pin"
                [formErrors]="formErrors"></app-field-validator>
            </div>
            <div class="ic1-col-12 buttons-container ic1-mt-16">
              <ng-ui-kit-button
                color="secondary"
                [label]="'PIN_PAGE.ACCORDION.FIRST_STEP.BTN_CANCEL' | translate"
                type="button"
                size="sm"
                (onClick)="clearForm(); closeModal()">
              </ng-ui-kit-button>
              <app-submit-button
                [label]="
                  'SUSPEND_PAGE.AUTOMATIC_CARD.BUTTON_TEXT'
                    | translate: { state: (buttonText | translate) }
                "
                translate-key="SUSPEND_PAGE.AUTOMATIC_CARD.BUTTON_TEXT"
                [loading]="loading"
                [disabled]="loading"
                (onClick)="goToSecondStep()">
              </app-submit-button>
            </div></div></ng-container
      ></ng-ui-kit-accordion>
    </div>
    <!-- SECOND STEP START -->
    <div class="ic1-my-16">
      <ng-ui-kit-accordion
        [disabled]="showStep1"
        [title]="'COMMON.ACCORDION_OTP.TITLE' | translate"
        [open]="showStep2"
        [step]="2">
        <ng-container content
          ><div class="desc ic1-mb-12" translate>COMMON.ACCORDION_OTP.DESC</div>
          <div class="ic1-col-12">
            <div class="ic1-form-group">
              <app-otp-input
                formControlName="otp"
                [error]="step2Attempted && otp.invalid"
                [errorDisclaimerText]="getManageCertOtpErrorDisclaimerText()"
                [startTimer]="showStep2"></app-otp-input>
            </div>
          </div>
          <div class="buttons-container ic1-mt-16">
            <button
              type="button"
              (click)="goToStepOne()"
              class="ic1-btn ic1-btn-sm ic1-btn-secondary cancel-button">
              <div translate>COMMON.BUTTON.CANCEL</div>
            </button>
            <app-submit-button
              type="submit"
              [loading]="loading"
              [disabled]="loading"
              [label]="'COMMON.BUTTON.CONFIRM' | translate"
              (onClick)="onSubmit()"></app-submit-button>
          </div>
        </ng-container>
      </ng-ui-kit-accordion>
    </div>
  </form>
</app-common-modal>
